import React from 'react';
import { ConfigStore } from '../../stores/ConfigStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { NumericPagination } from '../NumericPagination/NumericPagination';
import { Templates } from '../Templates/Templates';
import { SubHeader } from '../SubHeader/SubHeader';
import { CbdBanner } from '../CbdBanner/CbdBanner';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { NetworkErrorModal } from '../NetworkErrorModal/NetworkErrorModal';
import { templatesPageDataHooks } from './TemplatesPage.dataHooks';
import '../../styles/global.scss';
import styles from './TemplatesPage.scss';

interface TemplatesPageProps {
  configStore: ConfigStore;
  templatesStore: TemplatesStore;
  dataHook?: string;
}

const TemplatesPageCmp = (props: TemplatesPageProps) => {
  const { templatesStore, dataHook, configStore } = props;
  const isCBDCategory = templatesStore.loadedFetchParams?.subCategorySlug === 'cbd';

  return (
    <div data-hook={dataHook}>
      <SubHeader dataHook={templatesPageDataHooks.subHeader()} />
      <div className={styles.templatesWrapper}>
        <div className={styles.templates}>
          {isCBDCategory && (
            <div className={styles.cbdBannerWrapper}>
              <CbdBanner geoData={configStore.config.geoData} dataHook={templatesPageDataHooks.cbdBanner()} />
            </div>
          )}

          <Templates dataHook={templatesPageDataHooks.templates()} />
        </div>
      </div>

      <NumericPagination dataHook={templatesPageDataHooks.numericPagination()} />
      <NetworkErrorModal dataHook={templatesPageDataHooks.networkErrorModal()} />
    </div>
  );
};

export const TemplatesPage = injectStoresV2('templatesStore', 'configStore')(TemplatesPageCmp);
